import { useQueryClient } from '@tanstack/react-query';

import { type User } from './aliases';

import { RQ_USER_DATA_KEY } from '@/modules/ReactQuery/cacheKeys';

export function useCurrentUser(): [boolean, User | null] {
  const queryClient = useQueryClient();
  const user = queryClient.getQueryData<User>([RQ_USER_DATA_KEY]) || null;
  const authenticated = Boolean(user?.id);

  return [authenticated, user?.id ? user : null];
}
